module.exports = __webpack_public_path__ + "assets/img/s5.b8a58577.png";